
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center border-t border-border pt-8">
          <div className="mb-4 md:mb-0">
            <Link 
              to="/" 
              className="text-xl font-display font-bold text-foreground transition-opacity duration-200 hover:opacity-80"
            >
              Agents of Learning
            </Link>
            <p className="text-sm mt-2 text-muted-foreground">
              Interact with AI learning agents powered by Claude
            </p>
          </div>
          
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            <Link to="/about" className="text-foreground/80 hover:text-foreground transition-colors">
              About
            </Link>
            <Link to="/explore" className="text-foreground/80 hover:text-foreground transition-colors">
              Explore
            </Link>
            <Link to="/privacy" className="text-foreground/80 hover:text-foreground transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-foreground/80 hover:text-foreground transition-colors">
              Terms
            </Link>
          </nav>
        </div>
        
        <div className="mt-8 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Agents of Learning. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
